// ** Icon Imports
import { Icon } from '@iconify/react'

const Icone = ({ icon, ...rest }) => {
  return <Icon icon={icon} fontSize='1.375rem' {...rest} />
}

export default Icone
